import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  customer_id: payload.customer_id,
  location: payload.location,
  country: payload.country,
  price: payload.price,
  iva: payload.iva,
  total_price: payload.total_price,
  status: payload.status
})
var crud = new Crud('Projects', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  projects: [],
  project: {
    change_orders: []
  },
  catalog: {
    customers: []
  },
  isModalPurchaseOrdersVisible: false,
  isModalChangeStatusVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_MODAL_PURCHASE_ORDERS (state, payload) {
    state.isModalPurchaseOrdersVisible = payload
  },
  SET_MODAL_CHANGE_STATUS (state, payload) {
    state.isModalChangeStatusVisible = payload
  },
  UPDATE_RECORDS (state, payload) {
    const idx = state.projects.findIndex(u => u.id === payload.id)
    state.projects[idx] = payload
    if (idx >= 0) {
      Vue.set(state.projects, idx, payload)
    }
  }
}

const actions = {
  ...crud.actions,
  setModalPurchaseOrders ({ commit }, payload) {
    commit('SET_MODAL_PURCHASE_ORDERS', payload)
  },
  setModalChangeStatus ({ commit }, payload) {
    commit('SET_MODAL_CHANGE_STATUS', payload)
  },
  async editRecord ({ commit }, payload) {
    const record = model(payload)

    app.$Progress.start()
    try {
      const response = await axios.put(`projects/${payload.id}`, record)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORDS', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async uploadPdfFile ({ commit }, payload) {
    const formData = new FormData()
    formData.append('file', payload.file)

    app.$Progress.start()

    try {
      const response = await axios.post(`projects/${payload.id}/orders`, formData)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORDS', response.data)
        commit('SET_MODAL_PURCHASE_ORDER', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addChangeOrder ({ commit }, payload) {
    const formData = new FormData()
    formData.append('type', payload.record.type)
    formData.append('description', payload.record.description)
    formData.append('amount', payload.record.amount)
    formData.append('project_id', payload.id)
    payload.file && formData.append('file', payload.file)

    app.$Progress.start()

    try {
      const response = await axios.post(`projects/${payload.id}/change-orders`, formData)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_CHANGE_ORDERS', false)
        commit('UPDATE_RECORDS', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async exportPurchaseOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(payload)
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  exportChangeOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/change-orders/${payload.id}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async changeStatus ({ commit }, payload) {
    payload.status === 2 ? payload.finish_date = moment().format('YYYY-MM-DD') : payload.finish_date = null
    app.$Progress.start()

    try {
      const response = await axios.put(`projects/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORDS', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  projects: state => state.projects,
  project: state => state.project,
  catalog: state => state.catalog,
  isModalPurchaseOrdersVisible: state => state.isModalPurchaseOrdersVisible,
  isModalChangeStatusVisible: state => state.isModalChangeStatusVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
